import { FC, ReactElement } from 'react';
import Box from '@mui/material/Box';

// Components
import FooterDisclaimer from 'Components/FooterDisclaimer';
import SeoMetaTags from 'Components/SeoMetaTags';
import { Hero, Features, FAQ, Contact } from 'Pages/PoolsV2Transition';

const BorrowAccount: FC = (): ReactElement => {
  return (
    <>
      <SeoMetaTags
        title='Upgrading to Maple 2.0'
        description='From December 10th to December 12th the protocol will be paused as we upgrade the smart contracts and the user interface.'
        ogImage='https://downloads.maple.loans/migration-og-metatag.jpg'
        twitterImage='https://downloads.maple.loans/migration-twitter-metatag.jpg'
      />
      <Box sx={{ backgroundColor: 'ds.background.primary' }}>
        <Hero />
        <Features />
        <FAQ />
        <Contact />
      </Box>
      <FooterDisclaimer />
    </>
  );
};

export default BorrowAccount;
